import { Box } from '@mui/material';
const TheGuarantorsLogo = '/images/updated-logo.png';
const TheGuarantorsGLogo = '/images/tg-g-logo.svg';
const TransUnionLogo = '/images/TU-logo.svg';
const TransUnionMobileLogo = '/images/tu-mobile-logo.svg';
import { externalLinks } from '@/constants/Constants';
import { useGoToExternal } from '@/utils/linkUtils';
import { useReferralId } from '@/features/Registration/hooks/useReferralId';

interface HeaderLogoProps {
  isDesktop: boolean;
  isMobile: boolean;
}

const HeaderLogo = ({ isDesktop, isMobile }: HeaderLogoProps) => {
  const goToExternal = useGoToExternal();
  const { isTransunionReferral } = useReferralId();

  const handleLogoClick = () => {
    goToExternal(externalLinks.homePage, {
      title: 'Go to Main Page',
      path: '/home',
    });
  };

  if (isTransunionReferral) {
    if (isDesktop) {
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
          }}
        >
          <Box
            component="img"
            src={TheGuarantorsLogo}
            alt="theGuarantors"
            sx={{
              height: '24px',
              objectFit: 'contain',
            }}
          />
          <Box
            sx={{
              width: '1px',
              height: '32px',
              backgroundColor: '#000000',
            }}
          />
          <Box
            component="img"
            src={TransUnionLogo}
            alt="TransUnion"
            sx={{
              height: '45.8px',
              objectFit: 'contain',
              marginBottom: '11px',
            }}
          />
        </Box>
      );
    }

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <Box
          component="img"
          src={TheGuarantorsGLogo}
          alt="theGuarantors"
          sx={{
            height: '24px',
            objectFit: 'contain',
          }}
        />
        <Box
          sx={{
            width: '1px',
            height: '26px',
            backgroundColor: '#000000',
          }}
        />
        <Box
          component="img"
          src={TransUnionMobileLogo}
          alt="TransUnion"
          sx={{
            height: '26px',
            objectFit: 'contain',
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={TheGuarantorsLogo}
      alt="theGuarantors"
      onClick={handleLogoClick}
      sx={{
        width: isMobile ? undefined : '192px',
        height: isMobile ? '18.750px' : '25px',
        cursor: 'pointer',
      }}
    />
  );
};

export default HeaderLogo;
